import { render } from "./PaginationView.vue?vue&type=template&id=0b9476b6&ts=true"
import script from "./PaginationView.vue?vue&type=script&lang=ts"
export * from "./PaginationView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__